app.factory('baseOfCaseModel', ['$rootScope', 'baseOfCaseService',
    function($rootScope, baseOfCaseService) {

        function BaseOfCaseModel() {

            var self = this;

            self.selectedCriteriaList = null;
            self.selectCriteria = null;
            self.showResults = false;

            this.getAnonymizedData = function(searchCriteria) {
                baseOfCaseService.getAnonymizedData(searchCriteria).then(
                    function (anonymizedData) {
                        $rootScope.$broadcast(Event.BASE_OF_CASE.GET_ANONYMIZED_DATA.SUCCESS, anonymizedData);
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.BASE_OF_CASE.GET_ANONYMIZED_DATA.ERROR, error);
                    }
                )
            };

            this.getAnonymizedStateOfHealth = function(idVisitCard) {
                baseOfCaseService.getAnonymizedStateOfHealth(idVisitCard).then(
                    function (anonymizedStateOfHealth) {
                        $rootScope.$broadcast(Event.BASE_OF_CASE.GET_ANONYMIZED_STATE_OF_HEALTH.SUCCESS, anonymizedStateOfHealth);
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.BASE_OF_CASE.GET_ANONYMIZED_STATE_OF_HEALTH.ERROR, error);
                    }
                )
            };

            this.getAnonymizedVisitHistory = function(idVisitCard, visitHistoryRequest) {
                baseOfCaseService.getAnonymizedVisitHistory(idVisitCard, visitHistoryRequest).then(
                    function (anonymizedVisitHistory) {
                        $rootScope.$broadcast(Event.BASE_OF_CASE.GET_ANONYMIZED_VISIT_HISTORY.SUCCESS, anonymizedVisitHistory);
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.BASE_OF_CASE.GET_ANONYMIZED_VISIT_HISTORY.ERROR, error);
                    }
                )
            };

            this.getAnonymizedVisitCard = function(idVisitCard) {
                baseOfCaseService.getAnonymizedVisitCard(idVisitCard).then(
                    function (anonymizedVisitCard) {
                        $rootScope.$broadcast(Event.BASE_OF_CASE.GET_ANONYMIZED_VISIT_CARD.SUCCESS, anonymizedVisitCard);
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.BASE_OF_CASE.GET_ANONYMIZED_VISIT_CARD.ERROR, error);
                    }
                )
            };

            this.uploadFile = function (fileInput) {
                baseOfCaseService.uploadFile(fileInput).then(
                    function (file) {
                        $rootScope.$broadcast(Event.BASE_OF_CASE.UPLOAD_FILE.SUCCESS, file);
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.BASE_OF_CASE.UPLOAD_FILE.ERROR, error);
                    }
                )
            };

            $rootScope.$on(Event.MODULE_CHANGED, function(event, fromModule, toModule) {
                if (fromModule == Constant.MODULE.BASE_OF_CASE) {
                    self.selectedCriteriaList = null;
                    self.selectCriteria = null;
                }
            });
        }

        return new BaseOfCaseModel();
    }
]);
